import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH,
  BaseCoreState,
  BaseCustomerInquiryOfferInterface,
  BaseCustomerInquiryOfferShiftInterface,
  baseInquiryActions,
  BaseCustomerInquiryOfferDateInterface,
} from 'base';

@Component({
  selector: 'base-customer-offer-bubble-list',
  templateUrl: './base-customer-offer-bubble-list.component.html',
})
export class BaseCustomerOfferBubbleListComponent {
  @Input() offer: BaseCustomerInquiryOfferInterface;
  dayColumnWidth = BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH;

  constructor(private store: Store<BaseCoreState>) {}

  onBubbleClick(offerId: number, shift: BaseCustomerInquiryOfferShiftInterface, date: string): void {
    this.store.dispatch(baseInquiryActions.selectCustomerOfferBubble({ payload: { offerId, shift, date } }));
  }

  trackByDate(_: number, item: BaseCustomerInquiryOfferDateInterface) {
    return item.date;
  }

  trackByShift(_: number, item: BaseCustomerInquiryOfferShiftInterface) {
    return item.shift;
  }
}
